import { Checkbox, DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDetentionControl extends Layout {
    checkboxIsActive: Checkbox;
    sourceDetentionControl: DataSource;
    textboxDefaultHistViewDays: Textbox;
    textboxDepartureDist: Textbox;
    textboxEmailBilling: Textbox;
    textboxEmailErrors: Textbox;
    textboxExpireDays: Textbox;
    textboxTemplateEmail: Textbox;
}
